import { UserNotificationsPreferences } from '../schema/UserNotificationPreference';
import {
    getIsUserCustomPropertiesInitializedPromise,
    getUserCustomProperties,
} from '../utils/userCustomProperties';

/**
 * Get notification preferences of user from SDS (substrate data store).
 */
export const getUserNotificationPreferences = async (): Promise<UserNotificationsPreferences> => {
    const USER_NOTIFICATION_PREFERENCES = 'userNotificationPreferences';
    await getIsUserCustomPropertiesInitializedPromise();
    const userCustomProperties = getUserCustomProperties();
    if (userCustomProperties) {
        if (USER_NOTIFICATION_PREFERENCES in userCustomProperties) {
            return userCustomProperties[USER_NOTIFICATION_PREFERENCES];
        }
    }
    return null;
};
